import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts'
import { IS_SSR, IsDevEnv, Settings, SiteUrl } from '@/config'

export const getOidcConfig = (): UserManagerSettings => {
  const { authority, clientId, redirectUri, endpoints, scopes } = IsDevEnv ? Settings.ConnectID : Settings.ConnectIDProd

  const config: UserManagerSettings = {
    authority,
    client_id: clientId,
    redirect_uri: redirectUri,
    post_logout_redirect_uri: SiteUrl,
    response_type: 'code',
    scope: scopes,
    automaticSilentRenew: true,
    metadata: {
      authorization_endpoint: endpoints.authorizationEndpoint,
      token_endpoint: endpoints.tokenEndpoint,
      end_session_endpoint: endpoints.logoutEndpoint,
    },
  }

  if (!IS_SSR) {
    config.userStore = new WebStorageStateStore({ store: window.localStorage })
  }

  return config
}
